import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';
import './Charts.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const EstimatedVsActualChart = ({ tasks, users = [] }) => {
  const members = users.length
    ? users.filter(u => u.role === 'member').map(u => u.name)
    : [...new Set(tasks.map(t => t.assignedMember || t.userName).filter(Boolean))].sort();
  const memberHours = {};
  members.forEach(m => { memberHours[m] = { estimated: 0, actual: 0 }; });
  tasks.forEach(task => {
    const name = task.assignedMember || task.userName;
    if (!memberHours[name]) memberHours[name] = { estimated: 0, actual: 0 };
    memberHours[name].estimated += Number(task.estimatedTime) || 0;
    memberHours[name].actual += Number(task.actualTime) || 0;
  });

  const labels = members;
  const estimatedData = labels.map(m => memberHours[m].estimated);
  const actualData = labels.map(m => memberHours[m].actual);
  const hasData = [...estimatedData, ...actualData].some(v => v > 0);

  if (!hasData) {
    return (
      <div className="chart-container">
        <div className="chart-empty-state"><p>No hours data</p></div>
      </div>
    );
  }

  const chartData = {
    labels,
    datasets: [
      { label: 'Estimated (h)', data: estimatedData, backgroundColor: 'rgba(71, 85, 105, 0.8)', borderRadius: 4 },
      { label: 'Actual (h)', data: actualData, backgroundColor: 'rgba(59, 130, 246, 0.8)', borderRadius: 4 }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom', labels: { padding: 12, usePointStyle: true } },
      tooltip: { mode: 'index' }
    },
    scales: {
      y: { beginAtZero: true, ticks: { callback: v => v + 'h' }, grid: { color: 'rgba(0,0,0,0.06)' } },
      x: { grid: { display: false } }
    }
  };

  return (
    <div className="chart-container">
      <h4 className="chart-title">Estimated vs actual hours</h4>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default EstimatedVsActualChart;
